import { Component, OnInit } from '@angular/core';
import { AlertServiceService } from 'src/app/service/alert/alert-service.service';
import { FileDownloadService } from 'src/app/service/file-download/file-download.service';

@Component({
  selector: 'app-new-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.scss'],
})
export class NewFooterComponent implements OnInit {
  constructor(
    private fileDownloadService: FileDownloadService,
    private alert: AlertServiceService,
  ) {}

  ngOnInit(): void {}

  currentYear = new Date().getFullYear();

  downloadMerchantAgreement(): void {
    this.alert.showLoading();
    const fileUrl = 'assets/downloads/HP-SERVICE-LEVEL-E-AGREEMENT.docx';
    this.fileDownloadService.downloadFile(fileUrl).subscribe((data) => {
      const blob = new Blob([data], { type: data.type });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'HP-SERVICE-LEVEL-E-AGREEMENT.docx';
      link.click();
      this.alert.hideLoading('File already Downloaded');
    });
  }
}
